/* MAOMAO Sterne-Renderer v2 (260710)
   PROBLEM: Judge.me-Embed wird auf duplizierten Themes nicht ausgeliefert; jdgm.js (via
   mm-jdgm-fallback) blendet die server-seitig gerenderten Preview-Badges nie ein. Die DATEN
   sind aber da (Metafeld judgeme.badge: data-average-rating / data-number-of-reviews).
   LOESUNG: Eigene v5-Sternezeile, unabhaengig von Judge.me-JS/CSS.
   v2-WICHTIG: NICHT in den .mm-card__rating-Wrapper rendern — der traegt jdgm-widget-Klassen
   und wird von jdgm.js NACHTRAEGLICH neu befuellt/versteckt („Noch keine Bewertungen“-Kampf).
   Stattdessen: Daten VOR jdgm auslesen, Sternezeile als GESCHWISTER-Element danach einfuegen,
   Wrapper bleibt per CSS dauerhaft versteckt (.mm-card__rating{display:none!important}).
   - Kacheln: ★★★★★ (40) · PDP: Zeile unter H1 „★★★★★ 4,95 · 40 Bewertungen“ → scrollt zu Reviews
   - Teilsterne via CSS-Gradient (--p), MutationObserver fuer AJAX-Grids. Nur bei >=1 Review. */
(function(){
  'use strict';
  function starRow(rating,count,big){
    var pct=Math.max(0,Math.min(100,rating/5*100));
    var el=document.createElement(big?'a':'span');
    el.className=(big?'mm-stars mm-stars--pdp':'mm-stars mm-card__stars');
    var label=big?(rating.toFixed(2).replace('.',','))+' · '+count+' Bewertung'+(count===1?'':'en'):'('+count+')';
    el.innerHTML='<span class="mm-stars__track" style="--p:'+pct+'%" aria-hidden="true">★★★★★</span><span class="mm-stars__count">'+label+'</span>';
    el.setAttribute('aria-label',rating+' von 5 Sternen, '+count+' Bewertungen');
    if(big){
      el.href='#jdgm-reviews';
      el.addEventListener('click',function(e){
        e.preventDefault();
        var w=document.querySelector('.jdgm-rev-widg')||document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)');
        if(w)w.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
    return el;
  }
  function readBadge(scope){
    var b=scope.querySelector('.jdgm-prev-badge[data-average-rating]');
    if(!b)return null;
    return {rating:parseFloat(b.getAttribute('data-average-rating')||'0'),count:parseInt(b.getAttribute('data-number-of-reviews')||'0',10)};
  }
  function boot(){
    /* Kacheln: Daten lesen, Sterne ALS GESCHWISTER hinter den (versteckten) jdgm-Wrapper */
    document.querySelectorAll('.mm-card__rating').forEach(function(wrap){
      if(wrap.getAttribute('data-mm-stars'))return;
      var d=readBadge(wrap);
      if(!d)return;
      wrap.setAttribute('data-mm-stars','1');
      if(d.count>0&&d.rating>0){
        wrap.insertAdjacentElement('afterend',starRow(d.rating,d.count,false));
      }
    });
    /* PDP: Zeile unter dem Titel */
    if(location.pathname.indexOf('/products/')>-1&&!document.querySelector('.mm-stars--pdp')){
      if(document.querySelector('.mm-meta .mm-stars')){return;} // v3 (260812): Liquid rendert die Sterne-Zeile bereits serverseitig (reviews-Metafeld, seit v5-PDP) — JS-Zeile nur noch als Fallback für Produkte ohne reviews-Metafeld, sonst DOPPELTE Bewertungszeile
      var d=readBadge(document);
      var h1=document.querySelector('h1');
      if(d&&h1&&d.count>0&&d.rating>0){
        h1.insertAdjacentElement('afterend',starRow(d.rating,d.count,true));
      }
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  var t=null;
  var mo=new MutationObserver(function(){clearTimeout(t);t=setTimeout(boot,350);});
  mo.observe(document.documentElement,{childList:true,subtree:true});
})();
